import { makeStyles } from '@fluentui/react-components';
import { Color } from 'libs/theme/src/lib/colors';

export const inAppNotificationStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
  },
  inAppNotificationFooter: {
    padding: '1.5rem',
    gap: '1.5rem',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-end',
    boxShadow: 'inset 0px 1px 0px var(--gray-200)',
    backgroundColor: Color.drawer_header_color,
  },
});
